import { isAxiosError } from 'axios'

/**
 * HTTP status of a failed request. Core's response interceptor rejects
 * with its own `ApiError` (which carries `status`), while a bare client
 * rejects with the axios error itself; support both.
 */
export function errorStatus(error: unknown): number | undefined {
  if (isAxiosError(error)) return error.response?.status
  if (
    error &&
    typeof error === 'object' &&
    typeof (error as { status?: unknown }).status === 'number'
  ) {
    return (error as { status: number }).status
  }
  return undefined
}

/**
 * Backend error code (`code` in the SAIVA error envelope) of a failed
 * request, from core's `ApiError` (`code`) or a bare axios error.
 */
export function errorCode(error: unknown): string | undefined {
  if (isAxiosError(error)) {
    const code: unknown = error.response?.data?.code
    return typeof code === 'string' ? code : undefined
  }
  if (
    error &&
    typeof error === 'object' &&
    typeof (error as { code?: unknown }).code === 'string'
  ) {
    return (error as { code: string }).code
  }
  return undefined
}
